/**
 * Detects if the current device is running iOS (iPhone, iPad, iPod).
 * Excludes Windows Phone which may have similar user agent strings.
 */
export const isIOS = (): boolean => {
  if (typeof window === 'undefined') return false;
  return (
    /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream
  );
};
